import {useEffect} from 'react';
/** Sets --mx/--my on the hovered card so CSS can paint a cursor spotlight (pointer devices only). */
export function useTechFx(selector='.av-card,.lr-card,.as-cell,.av-frame'){
 useEffect(()=>{
  if(!window.matchMedia('(hover:hover)').matches)return;
  const on=(e:MouseEvent)=>{const el=(e.target as Element|null)?.closest(selector) as HTMLElement|null;if(!el)return;const r=el.getBoundingClientRect();el.style.setProperty('--mx',(e.clientX-r.left)+'px');el.style.setProperty('--my',(e.clientY-r.top)+'px')};
  document.addEventListener('mousemove',on,{passive:true});
  return()=>document.removeEventListener('mousemove',on);
 },[selector]);
}
